import { priceFormatter } from '@2wunder/klarx-tool'
import { ColumnProps } from 'antd/lib/table'
import KTable from 'app/components/Modules/Table/KTable'
import { RecordType, TableProps } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

type CategoryItemTableProps = {
  ranges: string[]
  showInsurance?: boolean
} & Partial<TableProps<IPriceListCategorySegment>>

const Table: React.FC<CategoryItemTableProps> = ({
  dataSource: data,
  ranges,
  showInsurance = false,
  ...others
}) => {
  const { tRecordType, tComponent } = ToolBox.useString()

  const columns: ColumnProps<IPriceListCategorySegment>[] = [
    {
      title: tRecordType(RecordType.price_list_item),
      dataIndex: 'category_segment_name',
      width: 300,
      render: (_val: string, item: IPriceListCategorySegment) => item.categorySegment.name
    },
    ...ranges.map((range) => ({
      title: range,
      render: (item: IPriceListCategorySegment) => {
        const amount = getPrice(item, range)?.amount
        return amount ? priceFormatter(getPrice(item, range)?.amount) : '-'
      }
    })),
    showInsurance && {
      title: tComponent({
        componentType: 'core',
        componentName: 'table',
        recordType: RecordType.price_list_item,
        id: 'liability_limitation'
      }),
      width: 150,
      render: (_val: string, item: IPriceListCategorySegment) => {
        if (!item.insurancePrice) return '-'

        return priceFormatter(item.insurancePrice.amount)
      }
    },
    {
      title: '',
      className: 'td-action'
    }
  ].filter(Boolean)

  const getPrice = (priceListItem: IPriceListCategorySegment, range: string) => {
    return priceListItem.prices.find((price) => range.includes(price.range))
  }

  return (
    <KTable<IPriceListCategorySegment>
      dataSource={data || []}
      recordType={RecordType.price_list_item}
      params={{}}
      pagination={false}
      columns={[...columns]}
      {...others}
    />
  )
}

export default Table
